import { FieldProps, TextField, useFieldHelper } from 'framework/ui/field';

const ElectronicOptionAgreementField = (props: FieldProps) => {
  const { getValue, getLabel } = useFieldHelper(props);

  return <TextField label={getLabel()} value={getValue() ? 'Yes' : 'No'} />;
};

export default ElectronicOptionAgreementField;
